import React from 'react'
import { StyledImage } from './Image.style'

const Image: React.FC<React.ImgHTMLAttributes<any>> = (props) => {
    return <StyledImage {...props} />
}

export default Image
